import React, { PropsWithChildren } from 'react';
import primaryLogo from 'images/placer-logo-ai.svg';
import styles from './auth-page-wrapper.module.scss';

/**
 * This wrapper component is designed for all authentication pages that share the same
 * base design and structure.
 *
 */
export const AuthPageWrapper = ({ children }: PropsWithChildren<{}>) => {
    return (
        <div className={styles.authPageWrapper} data-testId="auth-page-wrapper">
            <div className={styles.placerLogoContainer}>
                <img className={styles.logo} src={primaryLogo} alt="Placer.ai Logo" />
            </div>
            <div className={styles.main}>{children}</div>
            <div className={styles.sideImageWrapper}>
                <div className={styles.sideImage} />
            </div>
        </div>
    );
};
